import React from 'react';
import SeoHead from '../components/SeoHead';
import Webform from '../components/Webform';

export default function KontaktPage() {
  return (
    <>
      <SeoHead
        title="Kontakt – Lone Hvid & Niels Boye | Ibjerget på Midtfyn"
        description="Kontakt Ibjerget på Midtfyn. Direkte kontakt til Lone Hvid (tarotkortterapi, foredrag, kunst) og Niels Boye (ansigtsterapi, kropsterapi, massage)."
        canonicalUrl="https://www.ibjerget.dk/kontakt"
      />

      {/* Hero */}
      <section className="relative pt-32 pb-16 sm:pt-40 sm:pb-24 bg-[#381d6e] text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src="https://assets.auxodev.dk/assets/1df9f3fb-cd3d-49d9-8f1a-8a59416f1b4e/behandlerrum.webp"
            alt="Ibjerget kontakt"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#381d6e] via-[#381d6e]/75 to-transparent" />

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#d9238c]/30 border border-[#d9238c]/40 text-[#f7eefa] text-xs font-semibold uppercase tracking-wider mb-6">
            <i className="fa-solid fa-envelope-open-text" aria-hidden="true"></i>
            <span>Direkte kontakt til den rette behandler</span>
          </span>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-[#faf5f9] tracking-tight leading-tight">
            Kontakt os
          </h1>
          <p className="mt-6 text-base sm:text-xl text-[#f7eefa] max-w-2xl mx-auto leading-relaxed font-normal">
            Herunder finder du direkte kontaktoplysninger til henholdsvis Lone Hvid og Niels Boye.
          </p>
        </div>
      </section>

      {/* Contact Grid Section */}
      <section className="py-20 sm:py-24 bg-[#faf5f9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Fælles Adresse Card */}
          <div className="max-w-4xl mx-auto mb-12 bg-white rounded-3xl p-6 sm:p-8 border border-[#edd5e8] shadow-sm flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4 text-center sm:text-left">
              <div className="w-12 h-12 rounded-2xl bg-[#d9238c]/20 text-[#d9238c] flex items-center justify-center shrink-0">
                <i className="fa-solid fa-location-dot text-xl"></i>
              </div>
              <div>
                <span className="text-xs font-semibold uppercase tracking-wider text-[#d9238c] block">
                  Besøgsadresse
                </span>
                <p className="font-serif text-xl sm:text-2xl font-bold text-[#1f142e]">
                  Ibjergvej 12, 5792 Årslev
                </p>
                <p className="text-xs text-[#9b1b66]">Midtfyn • Gratis parkering på grunden</p>
              </div>
            </div>

            <a
              href="https://maps.google.com/?q=Ibjergvej+12,+5792+Årslev"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 rounded-full bg-[#faf5f9] hover:bg-[#f0d9eb] text-[#1f142e] text-xs font-semibold border border-[#edd5e8] transition-colors inline-flex items-center gap-2 shrink-0"
            >
              <span>Åbn i Google Maps</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-[10px]"></i>
            </a>
          </div>

          {/* TWO SEPARATE CONTACT PANELS: LONE & NIELS */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16">
            
            {/* LONE HVID CARD */}
            <div className="bg-white rounded-3xl p-8 sm:p-9 border-2 border-[#edd5e8] hover:border-[#d9238c] shadow-sm transition-all duration-300 flex flex-col justify-between space-y-6">
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="px-3 py-1 rounded-full bg-[#faf5f9] text-[#9b1b66] text-xs font-bold uppercase tracking-wider">
                    Terapeut, kunstner og forfatter
                  </span>
                  <span className="text-xs text-[#d9238c] font-medium">Ibjerget</span>
                </div>

                <div>
                  <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#1f142e]">
                    Lone Hvid
                  </h2>
                  <p className="text-xs text-[#d9238c] font-semibold mt-1">
                    Terapeut, kunstner og forfatter • CVR: 42494445
                  </p>
                  <p className="text-xs text-[#9b1b66] mt-0.5">
                    Tarotkortterapi, Foredrag, Spirituelle bøger & Galleri
                  </p>
                </div>

                <div className="space-y-3 pt-2">
                  <a
                    href="tel:30297902"
                    className="flex items-center gap-3.5 p-3.5 rounded-2xl bg-[#faf5f9] hover:bg-[#faf5f9] border border-[#edd5e8] transition-colors group"
                  >
                    <div className="w-10 h-10 rounded-xl bg-[#d9238c] text-white flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform">
                      <i className="fa-solid fa-phone text-sm"></i>
                    </div>
                    <div>
                      <span className="text-[11px] uppercase tracking-wider text-[#9b1b66] font-semibold block">
                        Telefon (klik for opkald)
                      </span>
                      <span className="font-semibold text-base text-[#1f142e]">
                        30 29 79 02
                      </span>
                    </div>
                  </a>

                  <a
                    href="mailto:lone.hvid@hotmail.com"
                    className="flex items-center gap-3.5 p-3.5 rounded-2xl bg-[#faf5f9] hover:bg-[#faf5f9] border border-[#edd5e8] transition-colors group"
                  >
                    <div className="w-10 h-10 rounded-xl bg-[#381d6e] text-[#f7eefa] flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform">
                      <i className="fa-regular fa-envelope text-sm"></i>
                    </div>
                    <div className="min-w-0">
                      <span className="text-[11px] uppercase tracking-wider text-[#9b1b66] font-semibold block">
                        E-mail
                      </span>
                      <span className="font-semibold text-sm text-[#1f142e] truncate block">
                        lone.hvid@hotmail.com
                      </span>
                    </div>
                  </a>
                </div>

                <div className="text-xs text-[#9b1b66] bg-[#faf5f9] p-4 rounded-xl border border-[#edd5e8] space-y-1">
                  <p className="font-semibold text-[#1f142e]">Ydelser hos Lone:</p>
                  <p>• Status på dine chakraer (1-2 t, 500 kr.)</p>
                  <p>• Tarotkort-terapi m. problemløsning (2-3 t, 700 kr.)</p>
                  <p>• Foredrag & workshops (1.000 kr.)</p>
                  <p>• Galleri for spirituel kunst (efter aftale)</p>
                </div>
              </div>

              <div>
                <a
                  href="tel:30297902"
                  className="w-full py-3.5 px-6 rounded-full bg-[#d9238c] hover:bg-[#be1878] text-white font-semibold text-sm text-center shadow transition-colors flex items-center justify-center gap-2"
                >
                  <i className="fa-solid fa-phone"></i>
                  <span>Ring til Lone</span>
                </a>
              </div>
            </div>

            {/* NIELS BOYE CARD */}
            <div className="bg-white rounded-3xl p-8 sm:p-9 border-2 border-[#edd5e8] hover:border-[#d9238c] shadow-sm transition-all duration-300 flex flex-col justify-between space-y-6">
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="px-3 py-1 rounded-full bg-[#faf5f9] text-[#9b1b66] text-xs font-bold uppercase tracking-wider">
                    Krops- og psykoterapeut
                  </span>
                  <span className="text-xs text-[#d9238c] font-medium">Ibjerget</span>
                </div>

                <div>
                  <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#1f142e]">
                    Niels Boye
                  </h2>
                  <p className="text-xs text-[#d9238c] font-semibold mt-1">
                    Krops- og psykoterapeut • CVR: 12691807
                  </p>
                  <p className="text-xs text-[#9b1b66] mt-0.5">
                    ALT Ansigtsterapi, Kropsterapi, Healingmassage & Hotstone
                  </p>
                </div>

                <div className="space-y-3 pt-2">
                  <a
                    href="tel:66157902"
                    className="flex items-center gap-3.5 p-3.5 rounded-2xl bg-[#faf5f9] hover:bg-[#faf5f9] border border-[#edd5e8] transition-colors group"
                  >
                    <div className="w-10 h-10 rounded-xl bg-[#d9238c] text-white flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform">
                      <i className="fa-solid fa-phone text-sm"></i>
                    </div>
                    <div>
                      <span className="text-[11px] uppercase tracking-wider text-[#9b1b66] font-semibold block">
                        Telefon (klik for opkald)
                      </span>
                      <span className="font-semibold text-base text-[#1f142e]">
                        66 15 79 02
                      </span>
                    </div>
                  </a>

                  <a
                    href="mailto:niels@ibjerget.dk"
                    className="flex items-center gap-3.5 p-3.5 rounded-2xl bg-[#faf5f9] hover:bg-[#faf5f9] border border-[#edd5e8] transition-colors group"
                  >
                    <div className="w-10 h-10 rounded-xl bg-[#381d6e] text-[#f7eefa] flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform">
                      <i className="fa-regular fa-envelope text-sm"></i>
                    </div>
                    <div className="min-w-0">
                      <span className="text-[11px] uppercase tracking-wider text-[#9b1b66] font-semibold block">
                        E-mail
                      </span>
                      <span className="font-semibold text-sm text-[#1f142e] truncate block">
                        niels@ibjerget.dk
                      </span>
                    </div>
                  </a>
                </div>

                <div className="text-xs text-[#9b1b66] bg-[#faf5f9] p-4 rounded-xl border border-[#edd5e8] space-y-1">
                  <p className="font-semibold text-[#1f142e]">Ydelser hos Niels (500 kr. pr. beh.):</p>
                  <p>• ALT Ansigtsterapi (60-75 min.)</p>
                  <p>• Kropsterapi (ca. 60 min.)</p>
                  <p>• Healingmassage (60-75 min.)</p>
                  <p>• Hotstonemassage (ca. 65 min.)</p>
                  <p className="pt-1 text-[11px] text-[#d9238c] font-medium">
                    (Niels er Elektro Hyper Sensitiv, og derfor skal mobiltelefon og eventuel smartwatch være slukket under behandlingen)
                  </p>
                </div>
              </div>

              <div>
                <a
                  href="tel:66157902"
                  className="w-full py-3.5 px-6 rounded-full bg-[#d9238c] hover:bg-[#be1878] text-white font-semibold text-sm text-center shadow transition-colors flex items-center justify-center gap-2"
                >
                  <i className="fa-solid fa-phone"></i>
                  <span>Ring til Niels</span>
                </a>
              </div>
            </div>

          </div>

          {/* Webform til generelle henvendelser */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl border border-[#edd5e8] shadow-sm p-2 sm:p-4">
              <Webform
                formType="general"
                title="Send os en besked"
                subtitle="Har du spørgsmål til en behandling, foredrag eller kunst, så skriv til os her."
              />
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
